// @flow
import React, { useState } from 'react';
import classNames from 'classnames';
import { EventArtistCard } from 'components/molecules/eventArtistCard';
import { EventVenuesList } from 'components/molecules/eventVenuesList';
import { Image } from 'components/atoms/image';
import type { Event } from 'types/event';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: Event,
  onClick: () => void,
  className?: string,
};

export const EventCard = (props: Props) => {
  const { data, onClick, className } = props;
  const [imageLoaded, setImageLoaded] = useState(false);
  if (!data) {
    return null;
  }

  const { artists, venues } = data;
  if (artists.length === 0 || venues.length === 0) {
    return null;
  }

  const setOnload = () => {
    setImageLoaded(true);
  };

  const containerClass = classNames('event-card', className);

  return (
    <div className={containerClass}>
      <>
        <img
          className={'full'}
          onLoad={setOnload}
          style={{
            animation: imageLoaded ? 'opacityAnimation 2000ms' : 'none',
          }}
          src={data.poster}
          alt={'event-poster'}
        />
        <img
          className={'thumb'}
          src={data.thumbnail}
          alt={'broken'}
          style={{
            visibility: imageLoaded ? 'hidden' : 'visible',
            position: 'absolute',
            left: '0',
          }}
        />
      </>
      <div className={'venue-info'}>
        <EventVenuesList data={data.venues} className={className} />
      </div>
      <div className={'event-info'}>
        <EventArtistCard data={data} onClick={onClick} />
      </div>
    </div>
  );
};
